import React from "react"
import StandardButton from '../../app_components/StandardButton'
import SettingsLongTextInput from '../../form_sections/SettingsLongTextInput'
import Icon from '../../app_components/Icon'
import { semantic } from '@lexody/design-tokens'


class PauseOrCancelAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pauseAccountOpen: false,
      unpauseAccountOpen: false,
      cancelAccountOpen: false,
      cancelReason: '',
      accountCancelled: false,
      deleteAccountOpen: false,
      deleteSuccessful: false
    }
    this.pauseAccount = this.pauseAccount.bind(this)
    this.togglePause = this.togglePause.bind(this)
    this.unpause = this.unpause.bind(this)
    this.toggleCancel = this.toggleCancel.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.deleteUser = this.deleteUser.bind(this)
  }

  updateUser(data) {
    $.ajax({
      url: `../updateUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {

      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  pauseAccount() {
    this.togglePause()
    let data = {
      user: {
        status: 'Travelling'
      }
    }

    this.updateUser(data)
  }

  togglePause() {
    this.setState({
      pauseAccountOpen: !this.state.pauseAccountOpen
    })
  }

  unpause() {
    this.setState({
      pauseAccountOpen: false,
      unpauseAccountOpen: true
    })
    let data = {
      user: {
        status: 'Active'
      }
    }

    this.updateUser(data)
  }

  toggleCancel() {
    this.setState({
      cancelAccountOpen: !this.state.cancelAccountOpen
    })
  }

  toggleDeleteUser() {
    this.setState({
      deleteAccountOpen: !this.state.deleteAccountOpen
    })
  }

  deleteUser() {
    $.ajax({
      url: `../request_full_delete`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          deleteSuccessful: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  accountCancelled() {
    let data = {
      user: {
        cancel_reason: this.state.cancelReason,
        status: 'Cancelled'
      }
    }

    this.updateUser(data)

    this.setState({
      accountCancelled: true
    })
  }

  renderBackButton(label, onClick) {
    return (
      <button type="button" className="lex-account-flow__back" onClick={onClick}>
        <Icon
          name="arrow-left"
          size={16}
          color={semantic.primary.text.label}
        />
        {label}
      </button>
    )
  }

  renderShell(children) {
    return (
      <div className="lex-form-page lex-account-flow">
        {children}
      </div>
    )
  }

  renderSuccess(title, body) {
    return this.renderShell(
      <section className="lex-account-flow__card lex-account-flow__success">
        <h2 className="lex-account-flow__heading lex-account-flow__heading--destructive">{title}</h2>
        <p className="lex-account-flow__body">{body}</p>
      </section>
    )
  }

  render() {
    if (this.state.deleteSuccessful) {
      return this.renderSuccess(
        'Delete account initiated.',
        'Thanks for using Lexody! Have a great day :)'
      )
    }

    if (this.state.accountCancelled) {
      return this.renderSuccess(
        'Account successfully cancelled.',
        'Thanks for using Lexody! Have a great day :)'
      )
    }

    if (this.state.pauseAccountOpen) {
      return this.renderShell(
        <>
          {this.renderBackButton('Back', () => this.togglePause())}
          <section className="lex-account-flow__card">
            <h2 className="lex-account-flow__heading lex-account-flow__heading--primary">
              Success! You’re taking a break.
            </h2>
            <div className="lex-account-flow__hero lex-account-flow__hero--pause" aria-hidden="true" />
            <p className="lex-account-flow__body">
              Your profile is still active, but you will not appear in matches for other people, and you won’t receive any emails from us (unless someone messages you directly).
            </p>
            <p className="lex-account-flow__body">
              When you’re ready to dive back in, just reactivate your account! Take as long as you need. We’ll be here when you come back!
            </p>
            <div className="lex-form-actions">
              <StandardButton
                text="Reactivate account"
                primary
                fullWidth
                onClick={() => this.unpause()}
              />
            </div>
          </section>
        </>
      )
    }

    if (this.state.unpauseAccountOpen) {
      return this.renderShell(
        <>
          {this.renderBackButton('Back', () => this.setState({ unpauseAccountOpen: false, pauseAccountOpen: true }))}
          <section className="lex-account-flow__card">
            <h2 className="lex-account-flow__heading lex-account-flow__heading--primary">
              I’m back and stronger than ever!
            </h2>
            <div className="lex-account-flow__hero lex-account-flow__hero--unpause" aria-hidden="true" />
            <p className="lex-account-flow__body">
              Ready to rock n’ roll? Your account is fully active again!
            </p>
            <div className="lex-form-actions">
              <StandardButton
                text="See my matches"
                primary
                fullWidth
                onClick={() => window.location.assign('/friends')}
              />
            </div>
          </section>
        </>
      )
    }

    if (this.state.deleteAccountOpen) {
      return this.renderShell(
        <>
          {this.renderBackButton('Back', () => this.toggleDeleteUser())}
          <section className="lex-account-flow__card">
            <h2 className="lex-account-flow__heading lex-account-flow__heading--destructive">
              Delete account
            </h2>
            <p className="lex-account-flow__body">
              This will take up to 30 days. This option will delete all your identifying data. Please read our terms of use to understand more. This is NOT RECOVERABLE. Once requested, you will never, ever, ever, be able to recover this account.
            </p>
            <p className="lex-account-flow__body">
              Like, never. Seriously.
            </p>
            <div className="lex-form-actions">
              <StandardButton
                text="Nevermind, just cancel the account now."
                alert
                fullWidth
                onClick={() => this.accountCancelled()}
              />
              <StandardButton
                text="I still want a full delete of my data."
                variant="ghost"
                onClick={() => this.deleteUser()}
              />
            </div>
          </section>
        </>
      )
    }

    if (this.state.cancelAccountOpen) {
      return this.renderShell(
        <>
          {this.renderBackButton('Back', () => this.toggleCancel())}
          <section className="lex-account-flow__card">
            <h2 className="lex-account-flow__heading lex-account-flow__heading--destructive">
              Cancel account
            </h2>
            <p className="lex-account-flow__body">
              If you’re done forever, you can cancel your account immediately. You will not receive emails, people can not access your profile or message you.
            </p>
            <SettingsLongTextInput
              value={this.state.cancelReason}
              label="Tell us why you're leaving (optional)"
              attribute="cancelReason"
              placeholder="How can Lexody be better? Give us any feedback you’d like, so we can improve for future members!"
              onChange={(value, attribute) => this.setState({ [attribute]: value })}
              tone="grey"
            />
            <div className="lex-form-actions">
              <StandardButton
                text="Cancel account"
                alert
                fullWidth
                onClick={() => this.accountCancelled()}
              />
              <StandardButton
                text="Request a full delete of my account"
                variant="ghost"
                onClick={() => this.toggleDeleteUser()}
              />
            </div>
          </section>
        </>
      )
    }

    return this.renderShell(
      <>
        {this.renderBackButton('Settings', () => this.props.togglePauseContainer())}
        <header className="lex-form-page__header">
          <h1 className="lex-form-page__title">Pause or cancel account</h1>
          <p className="lex-form-page__subtitle">
            Take a break or close your account permanently.
          </p>
        </header>
        <button
          type="button"
          className="lex-account-flow__option"
          onClick={() => this.pauseAccount()}
        >
          <div className="lex-account-flow__optionHeader">
            <h2 className="lex-account-flow__optionTitle">Pause account</h2>
            <Icon
              name="arrow-right"
              size={16}
              color={semantic.primary.text.label}
            />
          </div>
          <p className="lex-account-flow__optionBody">
            Need to take a break from Lexody? Save your progress, and come back when you’re ready! You won’t be shown as a match to other members. You also won’t receive any emails, unless people message you directly.
          </p>
        </button>
        <button
          type="button"
          className="lex-account-flow__option lex-account-flow__option--destructive"
          onClick={() => this.toggleCancel()}
        >
          <div className="lex-account-flow__optionHeader">
            <h2 className="lex-account-flow__optionTitle">Cancel account</h2>
            <Icon
              name="arrow-right"
              size={16}
              color={semantic.error.text.label}
            />
          </div>
          <p className="lex-account-flow__optionBody">
            If you’re done forever, you can cancel your account immediately. You will not receive emails, people can not access your profile or message you.
          </p>
        </button>
      </>
    )
  }
}

export default PauseOrCancelAccount
